import { useState } from 'react';

export const useEnableNW = () => {
  const [nwEnabled, setNWEnabled] = useState<boolean>(false);

  const handleNWToggleChange = () => {
    setNWEnabled(!nwEnabled);
  };

  return {
    nwEnabled,
    handleNWToggleChange,
  };
};
